export default __webpack_public_path__ + "static/userjourney-391fd752eed8f35867027102972092fe.png";